export default "__VITE_ASSET__d51c7a05__"